import { Intent, MenuItem } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { matchers } from 'millan';
import * as React from 'react';
import { Text } from 'vet-bones/components';

import * as copy from 'src/templates/copy';

const CONTAINS_SPACE_MATCHER = new RegExp('\\s');
export const NO_SPECIAL_CHARACTERS_MATCHER = new RegExp(/^[a-zA-Z0-9_-]+$/);
export const IRI_MATCHER = new RegExp(
  `^${matchers.IRIREF.source.slice(1, -1)}$`
);

export const createNewIdentifierDelimiterItemRenderer =
  (testId?: string, allowIri?: boolean) =>
  // eslint-disable-next-line react/display-name
  (
    query: string,
    active: boolean,
    handleClick: React.MouseEventHandler<HTMLElement>
  ) => {
    // eslint-disable-next-line react/destructuring-assignment
    const trimmedQuery = query.trim();
    if (!trimmedQuery) {
      return undefined;
    }
    let errorMessage = '';
    if (trimmedQuery.match(CONTAINS_SPACE_MATCHER)) {
      errorMessage =
        copy.components.projectMapping.primaryIdentifier.invalidSpace;
    } else if (
      !trimmedQuery.match(
        allowIri ? IRI_MATCHER : NO_SPECIAL_CHARACTERS_MATCHER
      )
    ) {
      errorMessage =
        copy.components.projectMapping.primaryIdentifier.invalidCharacter;
    }

    if (errorMessage) {
      return (
        <MenuItem
          className="sd-menu-item-no-results"
          intent={Intent.DANGER}
          text={<Text ellipsize>{errorMessage}</Text>}
        />
      );
    }

    return (
      <MenuItem
        active={active}
        data-testid={testId}
        icon={IconNames.ADD}
        onClick={handleClick}
        shouldDismissPopover={false}
        text={copy.components.projectMapping.primaryIdentifier.staticText(
          trimmedQuery
        )}
      />
    );
  };
